import Content from "@/components/Content.tsx";
import ClubWagersPage from "@/friendlyWagers/ClubWagersPage.tsx";
import Header from "@/Header.tsx";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";

/** The club's Friendly Wagers: its markets coming up and the ones settled last. */
export const Route = createFileRoute('/_app/clubs/$club_uid/friendly-wagers')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});
    return <>
        <Header />
        <Content>
            <ClubWagersPage clubUid={params.club_uid!} />
        </Content>
    </>
}
